(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityTemplatesService', EntityTemplatesService);

    EntityTemplatesService.$inject = ['$http', '$q', 'UrlService', 'DataService'];

    function EntityTemplatesService($http, $q, UrlService, DataService) {
        var baseService = DataService('entitytemplate');
        var service = {};

        angular.extend(service, DataService('entitytemplate'));

        angular.extend(service, {
            deleteTemplate: deleteTemplate,
            getDocumentTemplates: getDocumentTemplates,
            getItemCount: getItemCount,
            getEntityPreview: getEntityPreview,
            getRelatedEntityTemplates: getRelatedEntityTemplates,
            getContacts: getContacts,
            getCopy: getCopy,
            multiCopy: multiCopy,
            multiDelete: multiDelete,
            getDefaultEntityFields: getDefaultEntityFields,
            getEntityCount: getEntityCount,
            count: count
        });

        return service;

        function deleteTemplate(id, deleteEntities) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entitytemplate/' + id;

            var req = {
                method: 'DELETE',
                url: requestUrl
            };

            var promise = $http(req).then(
                // Success
                function (response) {
                },
                //Error
                function (response) {
                    return $q.reject(response);
                }
                );

            return promise;
        }

        /*
         * Retrieve document templates for the specified entity template.
         *
         * @param {int} id - Entity template id for which the document templates are usable
         * @param {string} usageType - Usage for which the document templates are usable
         * @param {int} entityId - Entity used to populate the merge fields for File Name and File Descrption properties. Optional.
         *
         * @returns {array} Returns a list of document templates
         */
        function getDocumentTemplates(id, usageType, entityId) {
            var url = UrlService.getWebAPIUrl() + '/entitytemplate/' + id + '/documenttemplate/';
            var parameterString = '';

            if (!_.isNil(usageType) && usageType !== '') {
                parameterString += '?usageType=' +usageType;
            }

            if (!_.isNil(entityId) && entityId !== '') {
                parameterString += parameterString === '' ? '?' : '&';
                parameterString += 'entityId=' + entityId;
            }

            url += parameterString;

            var req = {
                method: 'GET',
                url: url
            };

            return $http(req).then(
                function (response) {
                    return response.data;
                });
        }

        /*
         * Retrieve the entity count for the specified entity template
         *
         * @param {int} id - Entity template for which the count is to be retrieved
         * @param {bool} deleted - Should the count be for deleted items
         *
         * @returns {int} Count of entities for the entity template
         */
        function getEntityCount(id, deleted) {
            var url = UrlService.getWebAPIUrl() + '/entitytemplate/' + id + '/entitycount';

            if (deleted === true) {
                url += '?deleted=true';
            }

            var req = {
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            return $http(req).then(
                function (response) {
                    return response.data;
                });
        }

        /*
         * Retrieve the item count for the specified entity template ids
         *
         * @param {array} ids - List of entity template ids for which the item count is to be retrieved
         *
         * @returns {array} Returns a list of entity templates and their respective item count
         */
        function getItemCount(ids) {
            var url = UrlService.getWebAPIUrl() + '/entitytemplate/itemcount';
            var parameterString = '';

            if (!_.isNil(ids) && _.isArray(ids)) {
                angular.forEach(ids, function (id) {
                    parameterString += parameterString.length > 0 ? '&' : '?';
                    parameterString += 'ids=' + id;
                });
            }

            url += parameterString;

            var req = {
                method: 'GET',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            return $http(req).then(
                function (response) {
                    return response.data;
                });
        }

        /**
         * Get preview name and description for an entity.
         *
         * @param {object} entity
         * @param {number} entityTemplateId
         *
         * @return {object} Entity "preview" object, with properties:
         *   - {string} PreviewNameText
         *   - {string} PreviewDescriptionText
         */
        function getEntityPreview(entity, entityTemplateId) {
            return $http.post(
                UrlService.getWebAPIUrl() + '/entitytemplate/' + entityTemplateId + '/preview',
                entity).then(
            function (response) {
                return response.data;
            });
        }

        /**
         * Get the specified entity template(s) and all their related entity templates.
         *
         * @param {number|object} entityTemplate - A number representing an entity template id,
         *     or an entity template object.
         * @return {array} An array of entity templates, including the entity template specified
         *     in the input parameter, and all of its related entity templates. This includes
         *     all deeply embedded and linked entity templates.
         */
        function getRelatedEntityTemplates(entityTemplate) {
            var entityTemplateIds = null;

            if (Number.isInteger(entityTemplate)) {
                entityTemplateIds = [entityTemplate];
            } else if (entityTemplate.Fields) {
                entityTemplateIds = _(entityTemplate.Fields)
                    .filter('FieldType', 'Relationship')
                    .map('EntityTemplateId')
                    .unique()
                    .value();
            } else {
                throw 'Could not get related entity templates, input is neither an integer or an entity template';
            }

            if (entityTemplateIds.length === 0) {
                return $q.when([]);
            } else {
                return $http.get(UrlService.getWebAPIUrl() + '/entitytemplate?' +
                    _.map(entityTemplateIds, function (n) { return 'RelatedIds=' + n; }).join('&'))
                    .then(getOk);
            }

            function getOk(response) {
                return response.data.EntityTemplates;
            }
        }

        /**
         * Returns a list of contacts for the specified entity template.
         *
         * @param {int} entityTemplateId - Id of entity for which the contacts will be retrieved.
         * @param {array} usageTypes - What the contact can be used for, E.g. 'Email', 'SMS', 'Fax'
         *
         * @return {promise} Promise resolves returning a list of contacts upon success.
         */
        function getContacts(entityTemplateId, usageTypes) {
            var requestUrl = UrlService.getWebAPIUrl() + '/entitytemplate/' + entityTemplateId + '/Contacts';
            var queryString = '';

            if (!_.isNil(usageTypes)) {
                angular.forEach(usageTypes, function (usageType) {
                    queryString += queryString.length > 0 ? '&' : '?';
                    queryString += 'usagetypes=' + usageType;
                });
            }

            return $http.get(requestUrl + queryString).then(
                function ok(response) { return response.data; }, null);
        }

        /**
         * GET a copy of entity template with the specified id
         */
        function getCopy(entityTemplateId) {
            return $http.get(UrlService.getWebAPIUrl() + '/entitytemplate/' + entityTemplateId)
                .then(function (response) {
                    if (!_.isNil(response) && !_.isNil(response.data)) {
                        delete response.data.UpdatedDate;
                        delete response.data.UpdatedBy;
                        delete response.data.CreatedDate;
                        delete response.data.CreatedBy;
                        delete response.data.Name;
                        delete response.data.PluralName;
                        delete response.data.Id;
                        response.data.SMSTemplates = [];
                        response.data.EmailTemplates = [];
                    }

                    return $q.when(response.data);
                });
        }

        /**
         * Deletes the specified entity templates
         *
         * @param {array} entityTemplateIds - An array of entity template ids for the entity templates to be deleted.
         * @return {promise} A promise resolved once the entity template deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(entityTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/entitytemplatedelete', entityTemplateIds);
        }

        /**
         * Create copies of the specified entity templates.
         *
         * @param {array} entityTemplateIds - An array of entity template ids for the entity templates to be copied.
         * @return {promise} A promise resolved once the entity template copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(entityTemplateIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/entitytemplatecopy', entityTemplateIds);
        }

        /**
         * Get an object with default field values for the specified entity template. This is used for the entity preview.
         *
         * @param {array} entityTemplates
         * @param {number|string} entityTemplateId
         * @param {array} parentTemplateIds - Working variable. An array of the parent template ids to avoid infinite recursion.
         *
         * @returns {object}
         */
        function getDefaultEntityFields(entityTemplates, entityTemplateId, parentTemplateIds) {
            var fields = {};

            // Ensure entity template ID is a number
            entityTemplateId = Number(entityTemplateId);

            if (_.isNil(parentTemplateIds)) {
                parentTemplateIds = [];
            } else {
                // Take a copy
                parentTemplateIds = parentTemplateIds.slice();
            }

            if (_.includes(parentTemplateIds, entityTemplateId)) {
                // Avoid infinite recursion
                return fields;
            }

            var entityTemplate = _.find(entityTemplates, { Id: entityTemplateId });

            if (!_.isNil(entityTemplate)) {
                parentTemplateIds.push(entityTemplate.Id);

                _.forEach(entityTemplate.Fields, function (entityTemplateField) {
                    var fieldIsSingleEmbeddedEntity =
                        entityTemplateField.FieldType === 'Relationship' &&
                        entityTemplateField.RelationshipType === 'Embedded' &&
                        entityTemplateField.Cardinality === 'One' &&
                        entityTemplateField.EntityTemplateId;

                    if (fieldIsSingleEmbeddedEntity) {
                        fields[entityTemplateField.Name] = getDefaultEntityFields(entityTemplates, entityTemplateField.EntityTemplateId, parentTemplateIds);
                    } else if (!_.isNil(entityTemplateField.Default)) {
                        fields[entityTemplateField.Name] = entityTemplateField.Default;
                    }
                });
            }

            return fields;
        }

        /**
         * Gets the count of entity templates
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/entitytemplate/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();